// Lib
import React, { useMemo } from 'react';

// Components
import Comment from './Comment';
import { MNComment } from '../../../common/comments/commentTypes';

type Props = {
    elementId: string;
    commentList: MNComment[];
    currentUserId: string;
    currentEditorId: string;
    currentEditorKey: string;
    startEditing: ({
        editorId,
        editorKey,
        editorFocusRect,
    }: {
        editorId: string;
        editorKey: string;
        editorFocusRect: DOMRect;
    }) => void;
};

const Thread = (props: Props) => {
    const { commentList, elementId } = props;

    if (!commentList || !commentList.length) return null;

    const sortedCommentList = useMemo(() => {
        return commentList.sort((commentA, commentB) => commentA.createdAt - commentB.createdAt);
    }, [commentList]);

    return (
        <div className="Thread">
            {sortedCommentList.map((comment) => (
                <Comment
                    {...props}
                    parentThreadElementId={elementId}
                    key={comment._id}
                    _id={comment._id}
                    userId={comment.userId}
                    text={comment.text}
                    content={comment.content}
                    createdAt={comment.createdAt}
                />
            ))}
        </div>
    );
};

export default Thread;
